var ColorScheme;
( (function(ColorScheme) {
    ColorScheme["DARK"] = "dark";
    ColorScheme["LIGHT"] = "light";
    ColorScheme["HIGH_CONTRAST_LIGHT"] = "hcLight";
    ColorScheme["HIGH_CONTRAST_DARK"] = "hcDark";
})(ColorScheme || (ColorScheme = {})));
export { ColorScheme };
